import { TextField, Dialog, DialogContent, DialogTitle, Button, InputLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import AddIcon from '@mui/icons-material/Add';
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import "./content.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addContent,
  deleteContent,
  getContent,
  contentFlagOff,
  deleteContentSchedule,
  addContentSchedule,
} from "../../Redux/Actions/contentAction";
import Image from "./component/image";
import Vedio from "./component/vedio";
import Url from "./component/url";
import PrimarySearchBar from "../../components/searchBar/searchbar";
import { Box } from "@mui/system";
import { imgUrl } from "../../api/api";
import { ReactComponent as UrlIcon } from "../../Assets/images/urlIcon.svg";
import DeleteModel from "../../components/deletemodel/DeleteModel";
import toast from "react-hot-toast";
import { getPlaylist } from "../../Redux/Actions/playlistAction";
import { getScreens } from "../../Redux/Actions/screenAction";


function Content({socketRef ,user }) {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { content, isContentAdding,isContentScheduled,isContentScheduledDeleted,isContentAdded,isDeleted } = useSelector(
    (state) => state.Content
  );
  const { playlist } = useSelector((state) => state.Playlist);
  const [openMediaPop, setOpenMediaPop] = useState(false);
  const [checkedContent, setCheckedContent] = useState(new Set());
  const [dragOver, setDragOver] = useState(false);
  const [uploadQueue, setUploadQueue] = useState([]);
  const [urlContentForm, setUrlContentForm] = useState(false);
  const [urlName, setUrlName] = useState("");
  const [urlContent, setUrlContent] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDeleteId, setContentDeleteId] = useState("");
  const [previewItem, setPreviewItem] = useState(null);
  const [searchText,setSearchText]=useState('');
  const [isActive, setIsActive] = useState(false);
  const [contentID,setContentID]=useState('');
  const [filteredContent,setFilteredContent]=useState(null);
  const [sortField, setSortField] = useState('createdAt');
  const [sortDir, setSortDir] = useState('desc');
  const [openSchedule, setOpenSchedule] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [day, setDay] = useState([]);
  const [isScheduled, setIsScheduled] = useState(false);
  const [days, setDays] = useState([
    { _id: 1, day: "Mon", dayChecked: false },
    { _id: 2, day: "Tue", dayChecked: false },
    { _id: 3, day: "Wed", dayChecked: false },
    { _id: 4, day: "Thu", dayChecked: false },
    { _id: 5, day: "Fri", dayChecked: false },
    { _id: 6, day: "Sat", dayChecked: false },
    { _id: 7, day: "Sun", dayChecked: false },
  ]);
  useEffect(() => {
    const uid = user?._id;
    if (!uid) return;
    dispatch(getPlaylist(uid));
    dispatch(getScreens(uid));
    dispatch(getContent(uid));
  }, [user?._id, dispatch]);
  useEffect(()=>{
    if(isContentAdded){
      setFilteredContent(null);
      setSearchText('');
      dispatch(contentFlagOff());
    }
    if(isDeleted){
      setFilteredContent(null);
      setSearchText('');
      dispatch(contentFlagOff());
    }
    if (isContentScheduled) {
      toast.success("Playlist have scheduled");
      setIsScheduled(false);
      // const _checkingScreenAssing = screens.find(
      //   (s) => s.playlist?._id === playlistId
      // );
      // if (_checkingScreenAssing !== undefined) {
      //   emitOnScheduleAdd(_checkingScreenAssing.mac);
      // }
      dispatch(contentFlagOff());
    }
    if (isContentScheduledDeleted) {
      setOpenSchedule(false);
      toast.success("schedule deleted successfully");
      setIsScheduled(false);
      // const __checkingScreenAssing = screens.find(
      //   (s) => s.playlist?._id === playlistId
      // );
      // if (__checkingScreenAssing !== undefined) {
      //   emitOnScheduleAdd(__checkingScreenAssing.mac);
      // }
      dispatch(contentFlagOff());
    }
  },[isContentAdded,isDeleted,isContentScheduled,isContentScheduledDeleted])
  const handleClick = () => {
    // 👇️ toggle
    setIsActive(current => !current);

    // 👇️ or set to true
    // setIsActive(true);
  };

  function bytesToSize(bytes) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(
      Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)),
      10
    );
    if (i === 0) return `${bytes} ${sizes[i]}`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
  }
  const urlContentSubmit = () => {
    const form = new FormData();
    form.append("name", urlName);
    form.append("contenttype", "url");
    form.append("url", urlContent);
    form.append("role",user?.role);
    form.append("userId",user?._id);
    form.append('subuser',user?._id);
    dispatch(addContent(form));
    setOpenMediaPop(false);
  };
  const handleDeleteContent = (id) => {
    console.log(id)
    setOpenDialog(true);
    setContentDeleteId(id);
  };
  const confirmDeleteContent = () => {
    dispatch(deleteContent(contentDeleteId));
    setOpenDialog(false);
  };
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDir('asc');
    }
  };

  const getSortedData = (data) => {
    return [...data].sort((a, b) => {
      let valA = sortField === 'name' ? (a.name || '').toLowerCase() : new Date(a[sortField] || 0);
      let valB = sortField === 'name' ? (b.name || '').toLowerCase() : new Date(b[sortField] || 0);
      if (valA < valB) return sortDir === 'asc' ? -1 : 1;
      if (valA > valB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const displayContent = getSortedData(filteredContent !== null ? filteredContent : content);

  const searchHandler=(e)=>{
    setSearchText(e);
    if(e!==''){
      const searched=content.filter(p=>
        p.name?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) ||
        p.type?.toLocaleLowerCase().includes(e.toLocaleLowerCase())
      );
      setFilteredContent([...searched]);
    } else {
      setFilteredContent(null);
    }
  }

  const addSchedule = (contentid) => {
    const info = content.find((c) => c.id === contentid);
    console.log('from addSchedule=>',info)
    const __startDate = new Date(info?.schedule?.startDate)
      .toLocaleDateString()
      .split("/");
    const __endDate = new Date(info?.schedule?.endDate)
      .toLocaleDateString()
      .split("/");
    const isStartDateOneDigit = [1, 2, 3, 4, 5, 6, 7, 8, 9].find(
      (digit) => digit == __startDate[0]
    );
    const isEndDateOneDigit = [1, 2, 3, 4, 5, 6, 7, 8, 9].find(
      (digit) => digit == __endDate[0]
    );
    const _startDate = `${__startDate[2]}-${
      isStartDateOneDigit !== undefined
        ? "0" + isStartDateOneDigit
        : __startDate[0]
    }-${__startDate[1]}`.toString();
    const _endDate = `${__endDate[2]}-${
      isEndDateOneDigit !== undefined ? "0" + isEndDateOneDigit : __endDate[0]
    }-${__endDate[1]}`.toString();
    if (info?.schedule?.scheduled) {
      setIsScheduled(true);
      console.log("inside condition=>", info);
    }
    setContentID(contentid);
    setStartDate(_startDate);
    setEndDate(_endDate);
    setStartTime(info?.schedule?.startTime);
    setEndTime(info?.schedule?.endTime);
    setOpenSchedule(true);
    const dbDay = info.schedule.days;
    // console.log(dbDay)
    const sameArray = days.filter(
      (item) => !dbDay.find((d) => d.day === item.day)
    );
    // console.log([...sameArray,...dbDay]);
    setDays([...sameArray, ...dbDay]);
    setDay([...dbDay]);
  };

  const saveSchedule = () => {
    // console.log(day);
    dispatch(addContentSchedule(contentID,{
      startDate,
      endDate,
      startTime,
      endTime,
      days: day
    }));
    setDay([]);
    setOpenSchedule(false);
  };
  const deleteScheduleFromContent = (id) => {
    dispatch(deleteContentSchedule(id));
  };
  const emitOnScheduleAdd = (mac) => {
    const id = setTimeout(() => {
      socketRef.current?.emit("update_duration", { detail: { mac: mac } });
      clearTimeout(id);
    }, 2000);
  };
  const cancelSchedule = () => {
    setOpenSchedule(false);
    console.log([...days]);
    setDay([]);
    setDays([
      { _id: 1, day: "Mon", dayChecked: false },
      { _id: 2, day: "Tue", dayChecked: false },
      { _id: 3, day: "Wed", dayChecked: false },
      { _id: 4, day: "Thu", dayChecked: false },
      { _id: 5, day: "Fri", dayChecked: false },
      { _id: 6, day: "Sat", dayChecked: false },
      { _id: 7, day: "Sun", dayChecked: false },
    ]);
  };

  // Feature 1: build usedInMap
  const usedInMap = {};
  (playlist || []).forEach(p => {
    (p.content || []).forEach(c => {
      if (!usedInMap[c.content_id]) usedInMap[c.content_id] = [];
      usedInMap[c.content_id].push(p.name);
    });
  });

  // Feature 2 & 3: handlers
  const handleMultipleFiles = async (files) => {
    const fileArr = Array.from(files);
    setUploadQueue(fileArr.map(f => ({ name: f.name, status: 'pending' })));
    for (let i = 0; i < fileArr.length; i++) {
      const file = fileArr[i];
      setUploadQueue(q => q.map((item, idx) => idx === i ? { ...item, status: 'uploading' } : item));
      const form = new FormData();
      form.append("content", file);
      form.append("role", user?.role);
      form.append("userId", user?.role === 'admin' ? user?._id : false);
      form.append("subuser", user?.role === "user" ? user?._id : false);
      try {
        await dispatch(addContent(form));
        setUploadQueue(q => q.map((item, idx) => idx === i ? { ...item, status: 'done' } : item));
      } catch {
        setUploadQueue(q => q.map((item, idx) => idx === i ? { ...item, status: 'error' } : item));
      }
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length > 0) handleMultipleFiles(e.dataTransfer.files);
  };
  const toggleCheck = (id) => {
    setCheckedContent(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };
  const selectUnused = () => {
    const unusedIds = new Set(
      (filteredContent !== null ? filteredContent : content)
        .filter(item => !usedInMap[item.id] || usedInMap[item.id].length === 0)
        .map(item => item.id)
    );
    setCheckedContent(unusedIds);
  };
  const deleteChecked = () => {
    if (checkedContent.size === 0) return;
    if (!window.confirm(`${checkedContent.size}개 컨텐츠를 삭제하시겠습니까?`)) return;
    checkedContent.forEach(id => dispatch(deleteContent(id)));
    setCheckedContent(new Set());
  };

  const handleDayCheckbox = (e) => {
    const { name, checked, value } = e.target;
    // console.log(name,checked,value,days)
    if (checked) {
      setDay((prev) => [...prev, { day: value, dayChecked: true }]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: true };
      setDays([...days]);
      // console.log(selectedDayIndex)
    } else {
      setDay((prev) => [...day.filter((d) => d.day !== value)]);
      const selectedDayIndex = days.findIndex((d) => d._id == name);
      days[selectedDayIndex] = { ...days[selectedDayIndex], dayChecked: false };
      // console.log(selectedDayIndex)
      setDays([...days]);
    }
    // console.log('days array=>',days)
  };
  return (
    <Layout title="Content" user={user}>
      <div className="parent-container">

      <div className="child-container">
            <Box sx={{ px: 2, py: 1, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ flex: 1, minWidth: 160, background: 'white', borderRadius: '12px', px: 1 }}>
                <PrimarySearchBar value={searchText} onChange={searchHandler} />
              </Box>
              {searchText && (
                <button onClick={() => { setSearchText(''); setFilteredContent(null); }}
                  style={{ height: 40, background: 'none', border: '1px solid #ccc', borderRadius: '8px', padding: '0 14px', cursor: 'pointer', color: '#888', fontSize: '13px' }}>
                  초기화
                </button>
              )}
              <button
                style={{ height: 40, display: 'flex', alignItems: 'center', gap: 4, background: '#551FFF', color: 'white', border: 'none', borderRadius: '8px', padding: '0 20px', fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
                onClick={() => setOpenMediaPop(true)}
              >
                <AddIcon style={{ fontSize: 16 }} /> Add Content
              </button>
            </Box>
          </div>
          {
            isContentAdding && <>
            <Box sx={{
             position:'absolute',
             height:'100vh',
             width:'100vw',
             background:'rgba(0,0,0,0.5)',
             top:0,
             left:0,
             right:0,
             bottom:0,
             zIndex:'1000000',
             display:'flex',
             justifyContent:'center',
             alignItems:'center'
           }}>
             <img src="/images/spiner.gif"/>
           </Box>
            </>
          }
           
        {/* Feature 2: toolbar */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '8px 0', flexWrap: 'wrap' }}>
          <button onClick={selectUnused} style={{ background: 'white', color: '#551FFF', border: '1px solid #551FFF', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', cursor: 'pointer' }}>미사용만 선택</button>
          {checkedContent.size > 0 && (
            <>
              <span style={{ fontSize: '13px', color: '#551FFF' }}>{checkedContent.size}개 선택됨</span>
              <button onClick={deleteChecked} style={{ background: '#FF3B3B', color: 'white', border: 'none', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', cursor: 'pointer' }}>선택 삭제</button>
              <button onClick={() => setCheckedContent(new Set())} style={{ background: 'white', color: '#888', border: '1px solid #ccc', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', cursor: 'pointer' }}>취소</button>
            </>
          )}
        </div>
        <div className="content-list-header">
          <div className="content-list-header-checkbox">
            <input
              type="checkbox"
              checked={displayContent.length > 0 && displayContent.every(item => checkedContent.has(item.id))}
              onChange={() => {
                if (displayContent.every(item => checkedContent.has(item.id))) {
                  setCheckedContent(new Set());
                } else {
                  setCheckedContent(new Set(displayContent.map(item => item.id)));
                }
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className="content-list-header-thumb" />
          <div className="content-list-header-info">
            <button className={`sort-btn${sortField === 'name' ? ' sort-btn--active' : ''}`} onClick={() => handleSort('name')}>
              파일명 {sortField === 'name' ? (sortDir === 'asc' ? '↑' : '↓') : '↕'}
            </button>
          </div>
          <div className="content-list-header-usage">사용처</div>
          <div className="content-list-header-date">
            <button className={`sort-btn${sortField === 'createdAt' ? ' sort-btn--active' : ''}`} onClick={() => handleSort('createdAt')}>
              등록일 {sortField === 'createdAt' ? (sortDir === 'asc' ? '↑' : '↓') : '↕'}
            </button>
          </div>
          <div className="content-list-header-actions" />
        </div>
        <div className="content-render">
          {displayContent.map((item, index) => (
          <React.Fragment key={index}>
              {item.type === 'image' && <Image data={item} checked={checkedContent.has(item.id)} onCheck={toggleCheck} usedIn={usedInMap[item.id] || []} deleteSingleContent={handleDeleteContent} addSchedule={addSchedule} onPreview={setPreviewItem} />}
              {item.type === 'video' && <Vedio data={item} checked={checkedContent.has(item.id)} onCheck={toggleCheck} usedIn={usedInMap[item.id] || []} deleteSingleContent={handleDeleteContent} addSchedule={addSchedule} onPreview={setPreviewItem} />}
              {item.type === 'url' && <Url data={item} checked={checkedContent.has(item.id)} onCheck={toggleCheck} usedIn={usedInMap[item.id] || []} deleteSingleContent={handleDeleteContent} addSchedule={addSchedule} onPreview={setPreviewItem} />}
            </React.Fragment>
          ))}
          {filteredContent !== null && filteredContent.length === 0 && (
            <p style={{ color: '#888', padding: '20px', textAlign: 'center' }}>검색 결과가 없습니다.</p>
          )}
        </div>
      </div>

      <Dialog
        sx={{ zIndex: "10000000000000" }}
        open={openSchedule}
        onClose={() => setOpenSchedule(false)}
        maxWidth={"lg"}
      >
        <DialogTitle
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "700",
            marginBottom: "30px",
            // paddingBottom: '18px',
            borderBottom: "3px solid #551FFF",
          }}
        >
          <ScheduleSendIcon sx={{ color: "#551fff" }} /> Schedule
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              height: "50vh",
              width: "30vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "97%",
                width: "97%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-date">Start Date</InputLabel>
                  <TextField
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    id={"start-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-date">End Date</InputLabel>
                  <TextField
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    id={"end-date"}
                    type={"date"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  height: "20%",
                  width: "100%",
                  display: "flex",
                  gap: "10px",
                  border: "1px solid transparent",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="start-time">Start Time</InputLabel>
                  <TextField
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    id={"start-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel htmlFor="end-time">End Time</InputLabel>
                  <TextField
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    id={"end-time"}
                    type={"time"}
                    fullWidth
                  />
                </Box>
              </Box>

              <Box
                id={"days-id"}
                sx={{
                  minHeight: "20%",
                  margin: "10px 0",
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                {days.map((d, index) => {
                  return (
                    <>
                      <input
                        onChange={handleDayCheckbox}
                        name={d._id}
                        value={d.day}
                        checked={d.dayChecked ? true : false}
                        type={"checkbox"}
                        id={`day-${index}`}
                        style={{ display: "none" }}
                      />
                      <label
                        htmlFor={`day-${index}`}
                        style={{
                          cursor: "pointer",
                          borderRadius: "10px",
                          height: "50px",
                          width: "80px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "1px solid black",
                        }}
                      >
                        {d.day}
                      </label>
                    </>
                  );
                })}
              </Box>

              <Box
                sx={{
                  minHeight: "20%",
                  margin: "10px 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                <Button
                  variant={"outlined"}
                  type="button"
                  sx={{
                    width: "100px",
                  }}
                  onClick={cancelSchedule}
                >
                  Cancel
                </Button>
                <Button
                  variant={"contained"}
                  type="button"
                  sx={{
                    width: "100px",
                  }}
                  onClick={saveSchedule}
                >
                  Save
                </Button>
                {isScheduled ? (
                  <>
                    <Button
                      variant="contained"
                      color={"error"}
                      onClick={() => deleteScheduleFromContent(contentID)}
                    >
                      Delete
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={!!previewItem}
        onClose={() => setPreviewItem(null)}
        maxWidth="md"
        sx={{ '& .MuiDialog-paper': { maxHeight: '85vh', width: 'auto', maxWidth: '700px' } }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          {previewItem?.name}
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
          {previewItem?.type === 'image' && (
            <img
              src={`${imgUrl}/${previewItem.url}`}
              alt={previewItem.name}
              style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 12 }}
            />
          )}
          {previewItem?.type === 'video' && (
            <video
              src={`${imgUrl}/${previewItem.url}`}
              style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 12 }}
              controls
              autoPlay
            />
          )}
          {previewItem?.type === 'url' && (
            <Box sx={{ width: '100%' }}>
              <Typography variant="body2" sx={{ mb: 1, wordBreak: 'break-all', color: 'text.secondary' }}>
                {previewItem?.url}
              </Typography>
              <Box
                component="iframe"
                title={previewItem?.name || 'url-preview'}
                src={previewItem?.url}
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                sx={{
                  width: '100%',
                  height: { xs: 'min(50vh, 400px)', sm: 'min(70vh, 560px)' },
                  border: '1px solid #e5e7eb',
                  borderRadius: 2,
                  display: 'block',
                }}
              />
              <Box sx={{ textAlign: 'center', mt: 1.5 }}>
                <a href={previewItem?.url} target="_blank" rel="noreferrer" style={{ color: '#551FFF', fontWeight: 600 }}>
                  새 탭에서 열기
                </a>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>

    <DeleteModel
    open={openDialog}
    onClose={(e)=>setOpenDialog(e)}
    onConfirm={confirmDeleteContent}
    />

      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={openMediaPop}
        onClose={() => { setOpenMediaPop(false); setUploadQueue([]); setDragOver(false); }}
        sx={{
          zIndex:'100000000'
        }}
      >
        <DialogTitle style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '3px solid #551fff',
          fontSize: '18px',
          fontWeight: 700
        }}>
          <span style={{ flex: 1, textAlign: 'center' }}>Add Content</span>
          <button
            onClick={() => { setOpenMediaPop(false); setUploadQueue([]); setDragOver(false); }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#888', lineHeight: 1, padding: '0 4px' }}
          >✕</button>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {/* 드래그앤드롭 */}
            <div
              className={`drag-drop-zone${dragOver ? ' drag-over' : ''}`}
              onDragOver={e => { e.preventDefault(); e.stopPropagation(); setDragOver(true); }}
              onDragEnter={e => { e.preventDefault(); e.stopPropagation(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={handleDrop}
              onClick={() => document.getElementById('multi-file-input').click()}
              style={{ padding: '20px 16px' }}
            >
              <input id="multi-file-input" type="file" hidden multiple accept="image/*,video/*"
                onChange={e => handleMultipleFiles(e.target.files)} />
              <p style={{ fontSize: '14px', color: '#551FFF', fontWeight: 600, margin: '0 0 4px' }}>📁 드래그 앤 드롭 또는 클릭</p>
              <p style={{ fontSize: '12px', color: '#aaa', margin: 0 }}>이미지·동영상, 다중 선택 가능</p>
            </div>
            {/* 업로드 큐 */}
            {uploadQueue.length > 0 && (
              <div style={{ maxHeight: '140px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px', padding: '6px 12px' }}>
                {uploadQueue.map((item, i) => (
                  <div key={i} className="upload-queue-item">
                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '12px' }}>{item.name}</span>
                    <span style={{ fontSize: '11px', flexShrink: 0, color: item.status === 'done' ? '#22c55e' : item.status === 'error' ? '#ef4444' : item.status === 'uploading' ? '#551FFF' : '#aaa' }}>
                      {item.status === 'done' ? '✓ 완료' : item.status === 'error' ? '✗ 실패' : item.status === 'uploading' ? '업로드 중...' : '대기'}
                    </span>
                  </div>
                ))}
              </div>
            )}
            {/* URL 구분선 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ flex: 1, height: '1px', background: '#eee' }} />
              <span style={{ fontSize: '11px', color: '#aaa' }}>또는 URL 등록</span>
              <div style={{ flex: 1, height: '1px', background: '#eee' }} />
            </div>
            {/* URL 토글 버튼 */}
            <button
              onClick={() => { handleClick(); setUrlContentForm(!urlContentForm); }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', border: `1px solid ${isActive ? '#551FFF' : '#ddd'}`, borderRadius: '8px', padding: '10px', background: isActive ? 'rgba(85,31,255,0.05)' : 'white', cursor: 'pointer', color: '#551FFF', fontSize: '13px' }}
            >
              <UrlIcon style={{ width: 20, height: 20 }} />
              URL 추가
            </button>
            {urlContentForm && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '12px', background: '#fafafa', borderRadius: '8px' }}>
                <TextField variant="standard" value={urlName} onChange={(e) => setUrlName(e.target.value)} label="Title" fullWidth size="small" />
                <TextField variant="standard" value={urlContent} onChange={(e) => setUrlContent(e.target.value)} label="URL Link" fullWidth size="small" />
                <button style={{ marginTop: '8px', alignSelf: 'center' }} className="btn-save-content" onClick={urlContentSubmit}>
                  저장
                </button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}

export default Content;
